import { Component } from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute  } from '@angular/router';
import { Inject } from '@angular/core';
//import { Guid } from 'guid-typescript';
import { Observable, Subject, filter, take } from 'rxjs';
import { HttpClientModule, HttpHeaders, HttpClient, HttpParams } from '@angular/common/http'
import { environment } from 'src/environments/environment';
import {MatDialog} from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/shared/dialog/components/confirm-dialog/confirm-dialog.component';
import { ssoTargetsFor } from './sso-targets';

/// Redirect and logout targets for the host this page was loaded from. One
/// deployment serves Aramark's Philly users and the AraTrack IQ POC on two
/// hostnames; see ./sso-targets.ts.
const ssoTargets = ssoTargetsFor(environment);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

//const USERS_RESOURCE = 'https://explore-admin-dev-webapi.azurewebsites.net/ap/users';

///
/// The purpose of this component is to log an Aramark user into the app using
/// Auth0 and redirect the user to the Aramark TiberNet Admin tool (TNA).
///
/// This application will implement Auth0 SSO (connected to Aramark user db via Saml). A user that logs into this app and is validated will be redirected (url redirect) to TNA in a logged in state.
/// After a user is validated via Auth0 login, the Angular application will write a validation code (a guid) and a time stamp of the loggin time to the TNA user table.
/// The Angular application will then pass the userid/email address along with the approval code to TNA. TNA will look up the user id/email, approval code, and time stamp.
/// If the approval code matches for the user id and the timestamp is within a certain time range, then TNA will log the user in.
///
/// https://tibersoft.atlassian.net/wiki/spaces/AM/pages/1560182949/Implement+Single+Sign+On+SSO+for+Aramark+in+TNA+TiberNet+Admin
///
/// 1) log using in via Auth0
/// 2) Update user record in DB with timestamp and approval code code (guid)
/// 3) 
export class AppComponent {
  
  user: User | null | undefined;
  title = 'Aramark Login for TiberNet Admin (TNA)';
  guid = '';
  id = '';
  profileJson = '';
  redirectUrl  = ssoTargets.redirectUrlforTNA;
  timestamp : number = 0;
  ResponseFromApi : ResponseFromAPI | undefined;
  isLogout : string | null = '';


  constructor( @Inject(DOCUMENT) private document: Document, 
                                 public auth: AuthService, 
                                 private http: HttpClient, 
                                 private route: ActivatedRoute,
                                 private dialog: MatDialog
                                 ) {}

  ngOnInit(): void {

    /// Get url parameter: logout    
    let params = new URLSearchParams(window.location.search);
    this.isLogout = params.get('logout');
    console.log(this.isLogout)
    
    /// Check to see if user is logged in.
    /// Get email address.
    /// https://auth0.com/docs/libraries/auth0-angular-spa
    /// https://auth0.com/blog/complete-guide-to-angular-user-authentication/

    this.auth.isAuthenticated$
      .pipe(
            filter((isAuthenticated) => isAuthenticated),
            take(1)).subscribe((_)=>{

            //console.log('User is Authenicated');

            /// If user is logged in but parameter logout is true, then log out user.
            //console.log('isLogout value:')
            //console.log(this.isLogout)
            if (this.isLogout)
            {
              //console.log('Logging user out.');
              //this.auth.logout({returnTo: window.location.origin, federated: true });
              //this.auth.logout({ logoutParams: {returnTo: environment.auth.logoutUri, federated: true} });
              this.auth.logout({ logoutParams: {returnTo: ssoTargets.logoutUri} });
              return;
            }
            else
            {
              //console.log('still logged in.');
            }

            this.auth.user$.subscribe((user) => {
              this.user = user;
              
              //console.log('-----start user object ------');
              //console.log(this.user?.email);
              //console.log(this.user?.name);
              //console.log(this.user);
              //console.log('-----end user object ------');        
      
              //this.CreateGuid();
              //this.CreateTimestamp();
      
              this.UpdateUserInDb();
            });
      });
   
  }

  ///
  /// Update the user(email) record in the DB with a guid and a timestamp by calling an Azure function.
  /// guid represents an approval code.
  /// Time stamp is time of login. To be create and writen to DB by store procedure.
  UpdateUserInDb(): void {
    console.log('UpdateUserInDb:');

    this.UpdateUserWithSSO(this.user?.email? this.user?.email.toString() : "" ).subscribe(Response => {
      /// On success to the following.
      
      /// Get response from 
      this.ResponseFromApi  = Response;
      //console.log('Api Response:');
      //console.log(this.ResponseFromApi);

        /// Redirect to another URl
        //console.log('Redirect to URl:');
        this.goToUrl();      

    }, (error)=> {
        ///User was not update in the DB.

        /// Log the real failure so it is visible in the browser console.
        console.error('UpdateUserWithSSOApproval failed:', error);

          /// Display message. The HTTP status travels with it as a support
          /// reference, so a failed sign-in can be triaged without DevTools:
          /// 0   = the browser blocked the request before it was sent, i.e. this
          ///       origin is missing from the Function's CORS allowed origins,
          /// 401 = the Function rejected the Auth0 token (check its AUTH0_DOMAIN /
          ///       AUTH0_AUDIENCE app settings),
          /// 400 = the email has no admin row with PRIMARY_EMAIL_FLAG='Y' in the
          ///       database the Function points at.
          /// Compared against undefined, not truthiness: 0 is the CORS case and is
          /// exactly the status we most need to surface.
          const statusRef =
            error?.status !== undefined ? ' (ref: ' + error.status + ')' : '';
          const modalRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Error',
              message: 'An error has occurred. Please contact Tibersoft Support. (support@tibersoft.com)' + statusRef,
            },/* width: '400px', height: '200px',*/
          });

        ///Log User out... now done in \src\shared\dialog\components\confirm-dialog\confirm-dialog.component.ts
        //this.auth.logout({ logoutParams: {returnTo: environment.auth.logoutUri} });
    });
  }

  ///Log User out
  Logout() : void
  {
    this.auth.logout({ logoutParams: {returnTo: ssoTargets.logoutUri} });
  }


  ///
  /// This function is acting as Service call to call Azure function.
  /// It calls the azure function UpdateUserWithSSOApproval,
  /// Note the Azure function will call a store procedure.
  UpdateUserWithSSO (emailparam?: string): Observable<ResponseFromAPI>
  {
    /// set email parameter to pass to azure function
    const params = new HttpParams().set('email',emailparam? emailparam.toString() : '' );

    /// Set this value in header. This comes from azure Function App  - App key
    /// 
    const headers= new HttpHeaders()
    .set ('x-functions-key', environment.functionAppKey)
    
    //return this.http.post<ResponseFromAPI>("https://aramark-sso-dev.azurewebsites.net"+"api//UpdateUserWithSSOApproval", { params });
    //return this.http.post<ResponseFromAPI>(environment.apiUrl+"/UpdateUserWithSSOApproval", { params, 'headers': headers });
    //console.log('call service start:');

    /// Calling Azure function.
    ///a couple of ways to set this up.
    //return this.http.post<ResponseFromAPI>(environment.apiUrl+"/UpdateUserWithSSOApproval", { params } ,{headers});
    return this.http.post<ResponseFromAPI>(environment.apiUrl+"/UpdateUserWithSSOApproval", { email: emailparam } ,{headers});
    
    //console.log('call service end:');
  }

  ///
  /// https://stackoverflow.com/questions/34338440/how-to-redirect-to-an-external-url-in-angular2
  ///
  goToUrl(): void {

    /// Encoding email address in base64 before placing in Url.
    //console.log("base64 encoded email");
    let base64EncodeEmail: string = ""; 
    if (this.ResponseFromApi?.email != null)
    {
      base64EncodeEmail = btoa(this.ResponseFromApi?.email);
    }
    else 
    {
      base64EncodeEmail = '';
    }
    //console.log(base64EncodeEmail);

    ///Encoding approval code (guid) in base64 before placing in Url 
    //console.log("base64 encode guid");
    let base64EncodeGuid: string = "";
    if (this.ResponseFromApi?.generatedCode != null)
    {
      base64EncodeGuid = btoa(this.ResponseFromApi?.generatedCode.toString());
    }
    else 
    {
      base64EncodeGuid = '';
    }
    //console.log(base64EncodeGuid);

    /// Test code for decoding a string from base64
    //console.log(btoa("password"));
    //console.log("base64 decode of password");
    //console.log(atob("cGFzc3dvcmQ=")); //decode "password"
   
    /// For debugging redirect url without parameter encoded.
    //let  RedirUrlWithUnencodedParam: string = "";
    //RedirUrlWithUnencodedParam = this.redirectUrl + "key1=" + this.ResponseFromApi?.email + "&key2=" + this.ResponseFromApi?.generatedCode;
    //console.log('redirectUrl unencoded:');
    //console.log(RedirUrlWithUnencodedParam);

    /// Build Url with encoded parameters
    let  RedirUrlWithEncodedParam: string = "";
    RedirUrlWithEncodedParam = this.redirectUrl + "key1=" + base64EncodeEmail + "&key2=" + base64EncodeGuid;
    //console.log('redirectUrl encode:');
    //console.log(RedirUrlWithEncodedParam);

    /// Perform/Exceute redirect to TNA with encoded parameters
    this.document.location.href = RedirUrlWithEncodedParam;
  }


  ///
  /// Create a guid (not used now. created in azure function and passed back)
  /// https://stackoverflow.com/questions/42782645/how-to-create-guid-in-angular-2
  /// npm i guid-typescript --save
  ///
  CreateGuid(): void {
    this.guid = crypto.randomUUID();
    //console.log(this.guid);
  }


  ///
  /// Create a time stamp
  /// Originally the time stamp was going to be created here and passed into Azure function and store procedure.
  /// Now timestamp is being created in store procedure. 
  ///
  CreateTimestamp(): void {
    const current = new Date();
    const const_timestamp = current.getTime();
    this.timestamp = const_timestamp;
    //console.log('Timestamp:');
    //console.log(const_timestamp);
  }

}/// End class

///
/// This class will be used to hold the response from the API/azure function
///
export class ResponseFromAPI  { 
  email: string = '';
  generatedCode: number = 0;
  //timeStamp: number = 0; ///  note: timeStamp to be created in store procedure.
};